export default __webpack_public_path__ + "static/media/TVS KING GS+ 1.9b0a77ce.webp";